export const USER = 'user'
export const ADMIN = 'admin'
export const SUPER_ADMIN = 'super-admin'
export const MULTI_ADMIN = 'multi-admin'
export const MICROACTIONS_ROLES = [USER, ADMIN, SUPER_ADMIN, MULTI_ADMIN]
export const REVIEWS = 'reviews'
export const ROLE_MENU_NAMES = {
  [USER]: 'USER DASHBOARD',
  [ADMIN]: 'ADMIN PANEL',
  [SUPER_ADMIN]: 'SUPER ADMIN PANEL',
  [MULTI_ADMIN]: 'MULTI ADMIN PANEL',
}
